import { useAppDispatch, useAppSelector } from "hooks/redux/hooks";
import { useOkxBitcoinWallet } from "hooks/wallet/useOkxBitcoinWalletProvider";
import { useUnisatWallet } from "hooks/wallet/useUnisatWalletProvider";
import { useCallback, useEffect, useState } from "react";
import { getCurConnectWalletFlag } from "utils/store";
import axios from "utils/request/unisatBrc20"
import { setBalanceByBtc } from "hooks/redux/slices/brc20Slice";

const useBrc20Utils = () => {
    const { isConnected }= useAppSelector((state) => state.wallet)
    const { fromChain }= useAppSelector((state) => state.coreInfo)
    const [isBTC, setIsBTC] = useState(false)
    const [isUnisat, setIsUnisat] = useState(false)
    const { address: addressOkx } = useOkxBitcoinWallet()
    const { address: addressUnisat } = useUnisatWallet()
    const [address, setAddress] = useState('')
    const dispatch = useAppDispatch()

    useEffect(() => {
        if(fromChain?.nickName === 'BTC') {
            setIsBTC(true)
        } else {
            setIsBTC(false)
        }
    }, [fromChain])

    useEffect(() => {
        const curWalletFlag = getCurConnectWalletFlag()
        if(curWalletFlag === 'unisat') {
            setIsUnisat(true)
        } else {
            setIsUnisat(false)
        }
    }, [isConnected])

    useEffect(() => {
        if(isUnisat) {
            setAddress(addressUnisat)
        } else {
            setAddress(addressOkx)
        }
    }, [addressOkx, addressUnisat, isUnisat])

    const getBrc20Balance = useCallback(async () => {
        try {
            const result:any = await axios.get(`/address/${address}/brc20/summary?limit=1000`)
            if(result) {
                const { detail =[] } = result
                const tempObj: {[key: string]: string} = {}
                detail.forEach((item: any) => {
                    tempObj[item.ticker] = item.overallBalance
                });
                dispatch(setBalanceByBtc(tempObj))
            }
        } catch(error) {

        }
    }, [address, dispatch])

    return {
        isBTC,
        isUnisat,
        address,

        getBrc20Balance
    }
}

export default useBrc20Utils